{
	"privacy": {
		"tag": "Tietosuoja",
		"title": "Tietosuojaseloste",
		"updated": "Päivitetty 21.7.2026",
		"intro": "Re:Disc (\"me\") on käytettyjen frisbeegolf-kiekkojen osto- ja myyntipalvelu käyttäjältä käyttäjälle. Tämä seloste kertoo, mitä henkilötietoja keräämme, miksi, ja mitä oikeuksia sinulla on tietoihisi.",
		"controller": {
			"heading": "Rekisterinpitäjä",
			"body": "Re:Disc-palvelua ylläpitää yksityishenkilö Samu Tiainen harrasteprojektina — kyse ei ole rekisteröidystä yrityksestä. Jos sinulla on kysyttävää tästä selosteesta tai tiedoistasi, ota yhteyttä osoitteeseen samu.tiainen@hotmail.com."
		},
		"dataWeCollect": {
			"heading": "Mitä tietoja keräämme",
			"intro": "Keräämme vain palvelun toiminnan kannalta välttämättömät tiedot:",
			"items": [
				"Tilitiedot: sähköpostiosoitteesi ja salasanasi (tai Google-tilisi tiedot, jos kirjaudut Googlella) — näitä käsittelee tunnistautumispalveluntarjoajamme Clerk.",
				"Profiilitiedot: käyttäjänimi, maa, kaupunki ja toimitustapa-asetus, jos päätät lisätä ne.",
				"Ilmoitussisältö: kiekon tiedot, kuvaus, hinta ja kuvat, jotka lisäät myydessäsi kiekkoa.",
				"Viestit: ostajien ja myyjien välisten keskustelujen sisältö palvelussa.",
				"Tekniset tiedot: IP-osoite ja perustason lokitiedot, joita hosting-palveluntarjoajamme kerää automaattisesti tietoturvaa ja väärinkäytösten estämistä varten."
			]
		},
		"whyWeProcess": {
			"heading": "Miksi käsittelemme tietoja",
			"items": [
				"Tilisi luomiseen ja suojaamiseen sekä kiekkojen listaamisen, selaamisen ja niistä viestimisen mahdollistamiseen.",
				"Jotta ostajat ja myyjät voivat olla yhteydessä toisiinsa ilmoituksen tiimoilta.",
				"Ilmoitettujen ilmoitusten tai väärinkäytösten selvittämiseen ja palvelun toimivuuden ylläpitämiseen.",
				"Palvelun tietoturvan ylläpitämiseen ja petosten estämiseen."
			]
		},
		"sharing": {
			"heading": "Kenen kanssa jaamme tietoja",
			"intro": "Emme myy tietojasi. Tietoja jaetaan vain palveluntarjoajille, jotka pyörittävät sivustoa puolestamme:",
			"items": [
				"Clerk — hoitaa kirjautumisen, salasanat ja valinnaisen Google-kirjautumisen.",
				"Convex — isännöi sovelluksemme tietokantaa (ilmoitukset, viestit, profiilit).",
				"Netlify — isännöi verkkosivustoa ja sen lokeja.",
				"Google — vain jos valitset kirjautua Google-tililläsi."
			],
			"outro": "Emme käsittele maksuja emmekä hoida toimituksia — kaupat tapahtuvat suoraan ostajan ja myyjän välillä, joten emme koskaan näe maksutietojasi."
		},
		"retention": {
			"heading": "Kuinka kauan säilytämme tietoja",
			"body": "Säilytämme tili-, ilmoitus- ja viestitietojasi niin kauan kuin tilisi on aktiivinen. Jos poistat tilisi, poistamme profiilisi ja ilmoituksesi; osa tiedoista voidaan säilyttää hetken aikaa tämän jälkeen, jos se on tarpeen vireillä olevan riidan selvittämiseksi, väärinkäytöksen tutkimiseksi tai lakisääteisen velvoitteen täyttämiseksi."
		},
		"cookies": {
			"heading": "Evästeet",
			"body": "Käytämme tällä hetkellä vain välttämättömiä evästeitä — Clerkin asettamia evästeitä, jotka pitävät sinut kirjautuneena. Kieliasetuksesi tallennetaan selaimesi paikalliseen tallennustilaan, ei evästeeseen. Emme käytä analytiikka-, markkinointi- tai seurantaevästeitä. Jos tämä muuttuu, päivitämme tätä selostetta ja pyydämme suostumuksesi tarvittaessa."
		},
		"rights": {
			"heading": "Oikeutesi",
			"intro": "GDPR:n nojalla voit pyytää meitä:",
			"items": [
				"Antamaan pääsyn sinusta tallennettuihin henkilötietoihin.",
				"Korjaamaan virheelliset tiedot.",
				"Poistamaan tietosi (\"oikeus tulla unohdetuksi\").",
				"Rajoittamaan tai vastustamaan tietyn tyyppistä käsittelyä.",
				"Toimittamaan tietosi siirrettävässä muodossa."
			],
			"complaint": "Voit käyttää näitä oikeuksia lähettämällä sähköpostia osoitteeseen samu.tiainen@hotmail.com. Voit myös tehdä valituksen tietosuojavaltuutetun toimistolle (tietosuoja.fi), jos katsot tietojasi käsitellyn lainvastaisesti."
		},
		"changes": {
			"heading": "Muutokset tähän selosteeseen",
			"body": "Jos teemme olennaisia muutoksia tietojesi käsittelyyn, päivitämme tämän sivun yläreunassa olevan päivämäärän ja tarvittaessa ilmoitamme siitä sovelluksessa."
		}
	},
	"accessibility": {
		"tag": "Saavutettavuus",
		"title": "Saavutettavuusseloste",
		"updated": "Päivitetty 21.7.2026",
		"intro": "Tämä seloste koskee Re:Disc-verkkosivustoa. Haluamme, että sivusto on mahdollisimman monen käytettävissä, ja tavoitteenamme on WCAG 2.1 -tason AA mukainen saavutettavuus.",
		"compliance": {
			"heading": "Saavutettavuuden tila",
			"body": "Sivusto täyttää osittain WCAG 2.1 -tason AA vaatimukset. Olemme tehneet tarkoituksellisia korjauksia esimerkiksi värikontrastiin ja näppäimistökäyttöön, mutta kyseessä on itsearviointi — ulkopuolinen saavutettavuusauditoija ei ole vielä arvioinut sivustoa."
		},
		"knownIssues": {
			"heading": "Tunnetut puutteet",
			"intro": "Pyrkimyksistämme huolimatta osa sisällöstä ei välttämättä ole vielä täysin saavutettavaa:",
			"items": [
				"Myyjien lisäämissä kiekkojen kuvissa ei aina ole täydellisiä tekstivastineita, koska sisältö on käyttäjien tuottamaa.",
				"Uudempia ominaisuuksia ei ole välttämättä testattu yhtä perusteellisesti ruudunlukuohjelmilla ja muilla avustavilla teknologioilla kuin sivuston ydintoimintoja."
			]
		},
		"feedback": {
			"heading": "Palaute ja yhteystiedot",
			"body": "Jos törmäät saavutettavuusesteeseen sivustolla, lähetä sähköpostia osoitteeseen samu.tiainen@hotmail.com. Kerro, millä sivulla ongelma ilmeni ja mitä tapahtui — pyrimme selvittämään vahvistetut ongelmat ja korjaamaan ne."
		},
		"enforcement": {
			"heading": "Valvontamenettely",
			"body": "Jos et ole tyytyväinen saamaasi vastaukseen, voit ottaa yhteyttä Traficomiin (Liikenne- ja viestintävirasto), joka valvoo lain digitaalisten palvelujen tarjoamisesta noudattamista, osoitteessa saavutettavuusvaatimukset.fi."
		},
		"assessment": {
			"heading": "Miten tämä seloste on laadittu",
			"body": "Tämä seloste perustuu sivuston itsearviointiin WCAG 2.1 AA -kriteerejä vasten, joka tehtiin 21.7.2026."
		}
	},
	"terms": {
		"tag": "Ehdot",
		"title": "Käyttöehdot",
		"updated": "Päivitetty 21.7.2026",
		"intro": "Nämä ehdot koskevat Re:Discin käyttöä — käytettyjen frisbeegolf-kiekkojen osto- ja myyntipalvelua käyttäjältä käyttäjälle. Luomalla tilin tai käyttämällä sivustoa hyväksyt nämä ehdot.",
		"service": {
			"heading": "Mikä Re:Disc on",
			"body": "Re:Discin avulla käyttäjät voivat listata, selata ja viestiä toisilleen käytetyistä kiekoista. Emme ole osapuolena missään kaupassa — jokainen kauppa, mukaan lukien maksu ja toimitus, sovitaan suoraan ostajan ja myyjän välillä. Emme peri palvelumaksuja. Re:Disc-palvelua ylläpitää yksityishenkilö harrasteprojektina, ei rekisteröity yritys."
		},
		"eligibility": {
			"heading": "Kuka voi käyttää palvelua",
			"body": "Sinun tulee kyetä solmimaan sitova sopimus käyttääksesi Re:Disciä. Jos olet alle 18-vuotias, vahvistat, että sinulla on huoltajan lupa käyttää sivustoa sekä ostaa ja myydä sen kautta."
		},
		"accounts": {
			"heading": "Tilisi",
			"body": "Olet vastuussa tilisi ja ilmoitustesi tietojen paikkansapitävyydestä sekä kirjautumistietojesi turvaamisesta. Ilmoita meille, jos epäilet tilisi joutuneen vääriin käsiin."
		},
		"listings": {
			"heading": "Ilmoitukset ja käyttäytyminen",
			"intro": "Listatessasi kiekkoja tai käyttäessäsi sivustoa sitoudut olemaan:",
			"items": [
				"Julkaisematta virheellisiä, harhaanjohtavia tai väärennettyjä ilmoituksia.",
				"Listaamatta mitään, minkä myynti tai lähettäminen on laitonta kyseisessä maassa.",
				"Häiritsemättä, huijaamatta tai esiintymättä toisena käyttäjänä.",
				"Kaapimatta, kopioimatta tai väärinkäyttämättä sivustoa tai muiden käyttäjien sisältöä.",
				"Yrittämättä kiertää moderointia tai ilmoitustoimintoa."
			],
			"outro": "Voimme poistaa ilmoituksia, viestejä tai tilejä, jotka rikkovat näitä ehtoja, joko oman tarkastelumme tai käyttäjien ilmoitusten perusteella."
		},
		"transactions": {
			"heading": "Käyttäjien väliset kaupat",
			"body": "Koska emme ole osallisena missään kaupassa, emme tarkista ilmoituksia, käsittele maksuja, takaa toimitusta tai sovittele ostajien ja myyjien välisiä riitoja. Käytä tervettä järkeä: tarkista kunto ja tiedot ennen maksamista, ja ole varovainen tuntemattomien maksutapojen kanssa. Jos jokin menee pieleen tietyssä kaupassa, kyse on sinun ja toisen käyttäjän välisestä asiasta — voit kuitenkin ilmoittaa väärinkäytöksestä, jotta voimme puuttua tiliin."
		},
		"content": {
			"heading": "Sisältösi",
			"body": "Säilytät omistusoikeuden julkaisemiisi kuviin, kuvauksiin ja viesteihin. Julkaisemalla ne annat meille luvan näyttää niitä sivustolla, jotta palvelu voi toimia."
		},
		"disclaimer": {
			"heading": "Ei takuuta, rajoitettu vastuu",
			"body": "Re:Disc tarjotaan sellaisenaan, ilman minkäänlaisia takuita. Lain sallimissa rajoissa emme vastaa tappioista, jotka aiheutuvat ilmoituksista, kaupoista tai käyttäjien välisistä riidoista, tai palvelun käyttökatkoista tai virheistä. Tämä ei rajoita vastuuta, jota ei voida pakottavan lainsäädännön, mukaan lukien lakisääteisten kuluttajansuojaoikeuksien, nojalla rajoittaa."
		},
		"termination": {
			"heading": "Tilin jäädyttäminen ja poistaminen",
			"body": "Voimme jäädyttää tai poistaa tilin, joka rikkoo näitä ehtoja. Voit lopettaa sivuston käytön ja poistaa tilisi milloin tahansa."
		},
		"law": {
			"heading": "Sovellettava laki",
			"body": "Näihin ehtoihin sovelletaan Suomen lakia. Jos olet kuluttaja, asuinmaasi lain mukaiset pakottavat kuluttajansuojaoikeudet pätevät edelleen ja menevät tämän ehdon edelle, mikäli ne ovat ristiriidassa."
		},
		"changes": {
			"heading": "Muutokset näihin ehtoihin",
			"body": "Jos teemme olennaisia muutoksia, päivitämme tämän sivun yläreunassa olevan päivämäärän."
		},
		"contact": {
			"heading": "Yhteystiedot",
			"body": "Kysyttävää näistä ehdoista? Lähetä sähköpostia osoitteeseen samu.tiainen@hotmail.com."
		}
	}
}
